

















import Vue from 'vue'
import Panel from './Panel.vue'

export default Vue.extend({
  name: 'ShippingDeliveryImage',
  components: { Panel },
})
